module.exports = __webpack_public_path__ + "static/media/search.894f6455.svg";